import {
  Breakpoints,
  TextCustom,
  TextCustomProps,
  useIsMobile,
} from '@vw-marketing/us-components';
import React from 'react';
import {stringToPhoneFormat} from '../../utils/general';

interface ClickablePhoneProps {
  textStyle: TextCustomProps;
  phoneNumber?: string;
}
const ClickablePhone: React.FC<ClickablePhoneProps> = (props) => {
  const {textStyle, phoneNumber = ""} = props;
  const prettyNumber = stringToPhoneFormat(phoneNumber);
  const isMobile = useIsMobile(Breakpoints.b960);
  const onHandleClickPropagation: React.MouseEventHandler<HTMLAnchorElement> = (e) => {
    e.stopPropagation();
  }
  if (isMobile) {
    return <TextCustom {...textStyle}>
      <a href={'tel:' + prettyNumber} className="clickable-phone" onClick={onHandleClickPropagation}>{prettyNumber}</a>
    </TextCustom>;
  }
  return <TextCustom {...textStyle}>{prettyNumber}</TextCustom>;
};

export default ClickablePhone;
